import {
  Popup,
  Toast,
  Dialog,
  Button,
  Empty,
  Picker,
  DatetimePicker,
  Uploader,
  Loading,
  Tag,
  Tab,
  Tabs,
  Tabbar,
  TabbarItem,
  ActionSheet,
  Sticky,
  Switch,
  Swipe,
  SwipeItem,
  Image,
  ImagePreview,
  Icon,
  Lazyload,
  List,
  PullRefresh,
  NoticeBar,
  Checkbox,
  CheckboxGroup,
  Cell,
  CellGroup,
  Collapse,
  CollapseItem,
  Overlay,
  RadioGroup,
  Radio,
  Search,
  Area,
  Field,
  Circle,
  Progress
} from 'vant';

export default {
  install(Vue) {
    Vue.use(Toast)
      .use(Dialog)
      .use(Popup)
      .use(Picker)
      .use(Button)
      .use(Area)
      .use(Tag)
      .use(Empty)
      .use(Field)
      .use(DatetimePicker)
      .use(Uploader)
      .use(Loading)
      .use(Tab)
      .use(Tabs)
      .use(Search)
      .use(Tabbar)
      .use(TabbarItem)
      .use(ActionSheet)
      .use(Sticky)
      .use(Switch)
      .use(Swipe)
      .use(SwipeItem)
      .use(Image)
      .use(ImagePreview)
      .use(Lazyload)
      .use(List)
      .use(PullRefresh)
      .use(NoticeBar)
      .use(Checkbox)
      .use(CheckboxGroup)
      .use(Cell)
      .use(CellGroup)
      .use(Collapse)
      .use(CollapseItem)
      .use(Overlay)
      .use(RadioGroup)
      .use(Radio)
      .use(Circle)
      .use(Progress)
      .use(Icon);
  },
};
